import { nodeRedApi } from '../../services/axios';

export default async function getCieDetails() {
  try {
    const { data } = await nodeRedApi.get('/CieDetails');
    return data;
  } catch (error) {
    return [];
  }
}